import { render, staticRenderFns } from "./BackupTradesTable.vue?vue&type=template&id=66178595&"
import script from "./BackupTradesTable.vue?vue&type=script&lang=js&"
export * from "./BackupTradesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports